const strings = {
  todoListTitle: 'Todo List',
  todoListTabNameAllTasks: 'All Tasks',
  todoListTabNameCompleted: 'Completed',
  todoListTabNameActive: 'Active',
  addButton: 'Add',
  inputBoxPlaceholder: 'Add a task...',
  fetchingTasksLabel: 'Fetching your tasks...',
  todoItemAriaLabelCheckedState: 'This item is completed.',
  todoItemAriaLabelUncheckedState: 'This item is active.',
  todoItemAriaLabelTitle: 'The title is',
  deleteItemTitle: 'Delete this item.',
  deleteItemAriaLabel: 'Delete',
  workingOnSpinnerLabel: 'Working on...',
  titleEmptyErrorMessage: 'You can not leave this blank.'
};

export default strings;
